export { frequentlyAskedQuestionsParams } from './builder';
export { collectFrequentlyAskedQuestionsParams } from './collector';
export { FrequentlyAskedQuestions } from './FrequentlyAskedQuestions';
export type { FrequentlyAskedQuestionsProps } from './types';
